<template><section><h3>指针调整</h3>
<p>可以通过 <code v-pre>pointerWidth</code> 调整指针的宽度，值为<code v-pre>Number</code>或者<code v-pre>Array</code>。值若为<code v-pre>Array</code>，维度与 data 的维度保持一致；如果为<code v-pre>Number</code>则所有仪表盘的<code v-pre>pointerWidth</code>都为相同值。</p>
<p>指针支持通过 <code v-pre>style('pointer')</code>对颜色及属性进行修改</p>
<block-demo tip="" source="
const { Chart, Gauge, Legend, Tooltip } = qcharts

const chart = new Chart({ container: &#39;#app&#39; })

const gauge = new Gauge({
  min: 0,
  max: 100,
  percent:45,
  lineWidth: 20,
  // 修改指针宽度
  pointerWidth: 10,
  tickStep: 10
})

gauge
  .style(&#39;title&#39;, { fontSize: 36 })
  .style(&#39;arc&#39;, { strokeColor: &#39;#006666&#39; })
  .style(&#39;pointer&#39;, { fillColor: &#39;#006666&#39; })

chart.append(gauge)

setInterval(() =&gt; {
  const val = (Math.random() * 100).toFixed(0)
  gauge.attr({
    percent:val
  })
}, 3000)
"><pre v-pre><code v-pre class="language-javascript">
<span class="hljs-keyword">const</span> { Chart, Gauge, Legend, Tooltip } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({ <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span> })

<span class="hljs-keyword">const</span> gauge = <span class="hljs-keyword">new</span> Gauge({
  <span class="hljs-attr">min</span>: <span class="hljs-number">0</span>,
  <span class="hljs-attr">max</span>: <span class="hljs-number">100</span>,
  <span class="hljs-attr">percent</span>:<span class="hljs-number">45</span>,
  <span class="hljs-attr">lineWidth</span>: <span class="hljs-number">20</span>,
  <span class="hljs-comment">// 修改指针宽度</span>
  <span class="hljs-attr">pointerWidth</span>: <span class="hljs-number">10</span>,
  <span class="hljs-attr">tickStep</span>: <span class="hljs-number">10</span>
})

gauge
  .style(<span class="hljs-string">'title'</span>, { <span class="hljs-attr">fontSize</span>: <span class="hljs-number">36</span> })
  .style(<span class="hljs-string">'arc'</span>, { <span class="hljs-attr">strokeColor</span>: <span class="hljs-string">'#006666'</span> })
  .style(<span class="hljs-string">'pointer'</span>, { <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'#006666'</span> })

chart.append(gauge)

setInterval(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
  <span class="hljs-keyword">const</span> val = (<span class="hljs-built_in">Math</span>.random() * <span class="hljs-number">100</span>).toFixed(<span class="hljs-number">0</span>)
  gauge.attr({
    <span class="hljs-attr">percent</span>:val
  })
}, <span class="hljs-number">3000</span>)
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>